import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/auth/AuthProvider";
import { Button } from "@/components/ui/button";
import { ArrowLeft, LogIn } from "lucide-react";

export default function Login() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate("/admin", { replace: true });
  }, [user, loading, navigate]);

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-stone-50 px-6">
      <div data-testid="login-page" className="w-full max-w-md">
        <Link to="/" className="mb-10 inline-flex items-center gap-2 text-sm text-stone-500 hover:text-stone-900">
          <ArrowLeft className="h-4 w-4" strokeWidth={1.5} />
          Retour au site
        </Link>

        <div className="rounded-2xl border border-stone-200 bg-white p-8 shadow-sm sm:p-10">
          <div className="mb-6 flex items-center gap-3" translate="no">
            <img src="/logo-sad.svg?v=14" alt="Logo SAD" className="h-14 w-auto object-contain" />
            <p className="text-xs uppercase tracking-[0.22em] text-stone-500">Admin</p>
          </div>
          <h1 className="mt-2 text-3xl font-light tracking-tight text-stone-900">
            Espace réservé
          </h1>
          <p className="mt-3 text-sm text-stone-600">
            Connectez-vous avec votre compte Google autorisé pour accéder à la gestion des demandes de devis.
          </p>

          <Button
            data-testid="google-login-button"
            onClick={handleLogin}
            className="mt-8 h-12 w-full rounded-full bg-stone-900 text-stone-50 hover:bg-orange-800"
          >
            <LogIn className="mr-2 h-4 w-4" strokeWidth={1.5} />
            Continuer avec Google
          </Button>

          <p className="mt-6 text-xs leading-relaxed text-stone-400">
            Seules les adresses Google autorisées peuvent se connecter. Les autres
            tentatives sont automatiquement refusées.
          </p>
        </div>
      </div>
    </div>
  );
}
